import Logo_Impact_Soft from "../assests/images/Impact_Soft.png";

export const ImpactSoftLogo = () => (
    <img alt="logo" src={Logo_Impact_Soft} width="150.71" height="79.66" />
  );